// toolbar配置
const items = [
  // "source",
  // "|",
  'undo',
  'redo',
  '|',
  'preview',
  // "print",
  // "template",
  // "code",
  'cut',
  'copy',
  'paste',
  'plainpaste',
  'wordpaste',
  '|',
  'justifyleft',
  'justifycenter',
  'justifyright',
  'justifyfull',
  'insertorderedlist',
  'insertunorderedlist',
  'indent',
  'outdent',
  'subscript',
  'superscript',
  'clearhtml',
  'quickformat',
  // "selectall",
  '|',
  'fullscreen',
  '/',
  'formatblock',
  // "fontname",
  'fontsize',
  '|',
  'forecolor',
  'hilitecolor',
  'bold',
  'italic',
  'underline',
  'strikethrough',
  'lineheight',
  'removeformat',
  '|',
  'image',
  // "multiimage",
  // "flash",
  // "media",
  // "insertfile",
  // "table",
  'hr',
  // "emoticons",
  // "baidumap",
  'pagebreak',
  'anchor',
  'link',
  'unlink',
  '|',
  'about'
];

export default items;
